import React, { useEffect, useState } from "react";
import axios from "axios";
import { ShieldAlert } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "admin_act_as";

export const readActAs = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
};

// Admin-only: start acting as a school in this tab (logged server-side).
export const startActAs = async (tenantId) => {
  const { data } = await axios.post(`${API}/api/admin/act-as/${tenantId}`, {}, { withCredentials: true });
  localStorage.setItem("diag_session", JSON.stringify({ ...data.diag_session, loginAt: new Date().toISOString() }));
  sessionStorage.setItem(KEY, JSON.stringify({
    token: data.session_token, school: data.school_name, back: window.location.pathname + window.location.search,
  }));
  window.location.assign("/diagnostic");
};

export const exitActAs = async () => {
  const a = readActAs();
  try { if (a?.token) await axios.post(`${API}/api/admin/act-as/exit`, { session_token: a.token }); } catch { /* ignore */ }
  try { localStorage.removeItem("diag_session"); sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  window.location.assign(a?.back || "/app/myschoolrx");
};

// Bright, persistent banner on every page while an admin is acting as a school.
export const ActAsBanner = () => {
  const [a, setA] = useState(readActAs);
  useEffect(() => {
    const t = setInterval(() => setA(readActAs()), 1500);
    return () => clearInterval(t);
  }, []);
  if (!a) return null;
  return (
    <div className="sticky top-0 z-[70] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#f59e0b] px-4 py-2 text-sm font-semibold text-[#111827] shadow"
      data-testid="act-as-banner" role="status">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="break-words">You are acting as {a.school}</span>
      <span aria-hidden>·</span>
      <button onClick={exitActAs} data-testid="act-as-exit"
        className="min-h-[44px] rounded-md bg-[#111827] px-4 text-white hover:bg-black">Exit</button>
    </div>
  );
};
